import {Product} from "~/utils/Product";

export class Article {
    id = 0;
    article_number = "";
    details = "";
    anzahl_auftraege = 0;
    kaufdatum:Date|null = null
    location = ""
    neupreis = 0;
    product:Product = new Product()
    verkaufsdatum:Date|null = null
    verkaufspreis:number|null = null


    parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
        this.id = ret.id;
        this.article_number = ret.attributes.article_number;
        this.details = ret.attributes.Details
        this.anzahl_auftraege = ret.attributes.anzahl_auftraege
        this.kaufdatum = ret.attributes.kaufdatum
        this.location = ret.attributes.location
        this.neupreis = ret.attributes.neupreis
        this.verkaufsdatum = ret.attributes.verkaufsdatum
        this.verkaufspreis = ret.attributes.verkaufspreis
        if(ret.attributes.product && ret.attributes.product.data){
            this.product = new Product()
            this.product.parseJson(ret.attributes.product.data)
        }
    }
    toJSON () {
        return {...this} // here I make a POJO's copy of the class instance
    }
}
